<div class="container">
  <div class="text-center mb-4">
    <strong style="font-size: 1.5rem; color: #8E0E00;">SMS Log</strong>
  </div>

  <div class="row">
    <!-- Buttons -->
    <div class="col-lg-9 col-md-9 col-sm-12 toolbar d-flex align-items-center gap-2">
      <button class="btn btn-success" ngbTooltip="Export to excel"><span><i
            class="bi bi-box-arrow-up me-2"></i></span>
        Export</button>
      <!-- <button class="btn btn-success" ngbTooltip="Print">
        <span><i class="bi bi-printer me-2"></i></span>Print
      </button> -->
      <button class="btn btn-success" (click)="clearGrid()" ngbTooltip="Clear filter"><span> <i
            class="bi bi-x-circle me-2"></i></span>Clear Filter</button>
    </div>
    <!-- Search -->
    <div class="col-lg-3 col-md-3 mt-3 col-sm-12">
      <input type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchTerm"
        (input)="search($event)" />
    </div>
  </div>



  <div class="card shadow-lg p-3 mt-3">
    <div class="table-responsive">
      <table class="table table-striped table-bordered text-center">
        <thead>
          <tr>
            <th *ngFor="let row of tableHeaders;">{{ row }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of this.pagedData">
            <td>{{ row.userId }}</td>
            <td>{{ row.userType }}</td>
            <td>{{ row.userType === 'Individual Requester' ? row.userName : row.companyName }}</td>
            <td>{{ row.mobileNo }}</td>
            <td>{{ row.city }}</td>
            <td>{{ row.zone }}</td>
            <td>{{ row.smsCategory }}</td>
            <td class="text-start">{{ row.sms }}</td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="pagedData.length === 0" class="text-center mt-3">
        <strong>No data found</strong>
      </div>

      <!-- Pagination -->
      <div *ngIf="pagedData.length > 0" class="d-flex justify-content-center flex-grow-1">
        <div class="d-flex justify-content-center flex-grow-1">
        <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="sms?.length"
          (pageChange)="onPageChange($event)" [boundaryLinks]="true" [ellipses]="true" [maxSize]="3">
        </ngb-pagination>
        </div>         <!-- Entries Message Aligned to the End -->
      <div *ngIf="sms?.length > 0" class="text-muted mt-2">
        <strong>Showing {{ (page - 1) * pageSize + 1 }} to {{ (page * pageSize) > sms?.length ? sms?.length
          :page *pageSize }} of {{ sms?.length }} entries</strong>
      </div>
      </div>
    </div>
  </div>
</div>
